module.exports = __webpack_public_path__ + "img/Portrait-image.f60943cf.jpg";